import { useEffect, useState } from "react";
import { getUserRole } from "../modules/userRoles"; // Funkcja do pobierania ról użytkowników
import { auth } from "../config/firebase"; // Import Firebase Authentication

const useRole = (requiredRole) => {
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (auth.currentUser) {
        const role = await getUserRole(auth.currentUser.uid);
        console.log("Current user:", auth.currentUser);
        console.log("User role:", role);
        setHasAccess(role === requiredRole);
      } else {
        setHasAccess(false); // Brak użytkownika = brak dostępu
      }
    };

    fetchUserRole();
  }, [requiredRole]);

  return hasAccess;
};

export default useRole;